/*
  This file contains the logic for the cabinet form. 
 */

(function () {

  let include_leg_levelers = jQuery("#include_leg_levelers_input");
  let toe_kick_height = jQuery("#toe_kick_height_input");

  // Disable the toe kick height input if the checkbox is checked by default
  if (include_leg_levelers.is(":checked")) {
    toe_kick_height.prop("disabled", true);
  } else {
    toe_kick_height.prop("disabled", false);
  }

  // Show or hide the leveler legs based on the checkbox
  include_leg_levelers.change(function () {
    if (include_leg_levelers.is(":checked")) {
      toe_kick_height.val(102);
      toe_kick_height.prop("disabled", true);
      jQuery("#leveler_legs").show();
    } else {
      toe_kick_height.prop("disabled", false);
      jQuery("#leveler_legs").hide();
    }
  });

})();
